import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import createPersistedState from 'vuex-persistedstate'
// import objectPath from 'object-path'

import cognitoConfig from '../../config/cognito'
import CognitoAuth from '@smart/vue-auth-cognito'

import mutations from './mutations'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const devenv = process.env.NODE_ENV === 'dev'

const state = {
  tenant: 'smart',
  tenant_full_name: 'SMART Payment Plan'
}

const getters = {
  tenant: state => {
    return state.tenant
  }
}

/*
function clone (obj) {
  let copy = obj.constructor()
  for (let attr in obj) {
    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
  }
  return copy
}
*/

const persistedStateOptions = {
  /*
  reducer: function (state, paths) {
    (paths.length === 0
      ? state
      : paths.reduce((substate, path) => {
        objectPath.set(substate, path, objectPath.get(state, path))
        return substate
      }))
  }
  */
  reducer: function (state, paths) {
    // No need to use let as the reducer itself can be immutable which do not mean that the properties are not mutable (https://ponyfoo.com/articles/var-let-const)
    const reducer = Object.assign({}, state)
    // let reducer = clone(state)
    // state which you don't want to persist.
    // console.log(state)
    // delete reducer.cognito.cognitoUser

    return reducer
  }
}

const options = {
  state,
  modules: {
    cognito: new CognitoAuth(cognitoConfig)
  },
  mutations,
  getters,
  strict: debug,
  plugins: devenv ? [createLogger(), createPersistedState(persistedStateOptions)] : [createPersistedState(persistedStateOptions)]
}

export default new Vuex.Store(options)
export { options }



// WEBPACK FOOTER //
// ./src/store/index.js